import React, { useContext, useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import classNames from "classnames"
import { SelectedPlansContext } from "./SelectedPlansContext"
import styles from "./styles.module.scss"
import { CartIcon } from "./images/icons"

const Header = ({ userType }) => {
  const { selectedPlans, setSelectedPlans, toggleSubscriptionModal } =
    useContext(SelectedPlansContext)
  const headerRef = useRef(null)

  useEffect(() => {
    document.addEventListener("scroll", onScroll)

    return () => {
      document.removeEventListener("scroll", onScroll)
    }
  }, [])

  const onScroll = () => {
    if (window.scrollY > 50) {
      headerRef.current.style.boxShadow = "rgba(0, 0, 0, 0.1) 0 1px 2px 0"
    } else {
      headerRef.current.style.boxShadow = "none"
    }
  }

  return (
    <div className={styles.header} ref={headerRef}>
      <div className={styles.navbar}>
        <a href="/">
          <div className={styles.logo}></div>
        </a>

        <nav className={styles["nav-menu"]}>
          <a href="/p/jobs">Find Jobs</a>
          <a href="/candidate">For Candidate</a>
          <Link to="/client">For Employer</Link>
        </nav>

        <nav className={styles.session}>
          {selectedPlans.length > 0 && (
            <button
              className={classNames(styles.button, styles.dark)}
              onClick={toggleSubscriptionModal}
            >
              <CartIcon style={{ marginRight: "0.25rem" }} /> Subscribe (
              {selectedPlans.length})
            </button>
          )}

          {userType === "visitor" ? (
            <a href="/login">
              <button className={classNames(styles.button, styles.outline)}>
                Login
              </button>
            </a>
          ) : (
            <a href="/dashboard">
              <button className={classNames(styles.button, styles.dark)}>
                Dashboard
              </button>
            </a>
          )}
        </nav>
      </div>
    </div>
  )
}

export default Header
